const listeners = {};

export const GameEvents = {
  CREATURE_DEATH: "creatureDeath",
  CREATURE_HIT: "creatureHit",
  CREATURE_ATTACK: "creatureAttack",
  LIFESTEAL: "lifesteal",
  FIGHT_START: "fightStart",
  FIGHT_END: "fightEnd",
  RESPAWN_START: "respawnStart",
  RESPAWN_END: "respawnEnd",
  STATUS_APPLIED: "statusApplied",
  STATUS_EFFECT_TICK: "statusEffectTick",
  STATUS_DAMAGE: "statusDamage",
  STUN_SKIP: "stunSkip",
  ITEM_DROP: "itemDrop",
  ITEM_ADDED: "itemAdded",
  ITEM_CREATED: "itemCreated",
  SMELT_QUEUED: "smeltQueued",
  SMELT_CANCELLED: "smeltCancelled",
  SMELT_TICK: "smeltTick",
  SMELT_COMPLETE: "smeltComplete",
  SMITH_QUEUED: "smithQueued",
  SMITH_TICK: "smithTick",
  SMITH_COMPLETE: "smithComplete",
  SMELT_QUEUE_CLEARED: "smeltQueueCleared",
  SMITH_QUEUE_CLEARED: "smithQueueCleared",
};

export function on(event, callback) {
  if (!listeners[event]) listeners[event] = [];
  listeners[event].push(callback);
}

export function off(event, callback) {
  if (!listeners[event]) return;
  listeners[event] = listeners[event].filter((cb) => cb !== callback);
}

export function emit(event, data) {
  if (!listeners[event]) return;
  for (const callback of listeners[event]) {
    callback(data);
  }
}
